<template>
  <div>
    <v-container v-if="isIneligible" fluid class ="content-container">
      <v-layout row wrap>
        <v-flex md12 xs12 sm12>
          <div class="heading heading-top disable-message">Reader Accounts Disabled</div>
          <template>
            <div class="no-hero">
              <div class="message">
                To ensure that all authors can find a book to review, </br> Reader Accounts have been disabled at this time.
                <div class="sub-message">
                  Any assignments readers currently have can still be completed, and all snaps will still be honored upon review verification. 
                  Readers will not be able to take new assignments while this feature is disabled.
                </div>
                <div class="sub-message">
                If you are an author who was using a Reader Account to earn snaps prior to your own book launch, and want to continue using Pubby to get
                reviews for your own books, please contact support.
                </div>
              </div>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else fluid class="content-container">
      <v-layout row wrap>
        <v-flex md12 xs12 sm12>
          <div class="heading then-cardlist heading-top">Your Assignments</div>

          <template v-if="assignments.length">
            <list :assignments="assignments"></list>
          </template>
          <template v-else>
            <div class="no-hero">
              <div class="icon">
                <img
                  src="/images/icons/read.svg"
                  alt="No Books"
                  class="icon-img"
                />
              </div>
              <div class="message">Ready to start reading?</div>
              <div class="sub-message">
                You can find your first book to read in our library!
              </div>
            </div>
          </template>

          <v-container
            grid-list-md
            fluid
            pa-0
            class="table-container find-book-container"
          >
            <v-layout row wrap class="book-row">
              <v-flex xs12 sm12 md8 class="list-row">
                <div class="add-book-container">
                  <div class="add-book grow" @click="$router.push('/browse')">
                    <div class="add-icon">
                      <i class="material-icons">add</i>
                    </div>
                    <div class="add-label">Find Book</div>
                  </div>
                </div>
              </v-flex>
              <v-flex md4 class="hidden-sm-and-down"></v-flex>
            </v-layout>
          </v-container>

          <!-- <div class="heading">Book Results</div> -->
          <!-- <review-chart></review-chart> -->
        </v-flex>
        <v-flex md12 class="activity-col">
          <div class="heading then-cardlist align-with-top">Your Activity</div>
          <activity-timeline :events="events"></activity-timeline>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fluid
      class="content-container content-last hidden-sm-and-down"
    >
      <v-layout row wrap>
        <v-flex md12>
          <div class="heading then-card">Reading History</div>
          <template v-if="showHistoryTable">
            <reader-table></reader-table>
          </template>
          <template v-else>
            <div style="width: 80%">
              <no-content :half="true" icon="timeline"
                >Start reading to see some stats!</no-content
              >
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Head from "@/components/Page/Head";
import Heading from "@/components/Page/Heading";
import List from "@/components/Assignment/List";
import Back from "../modules/Back";
import Bus from "../modules/Bus";
import FindBook from "@/components/Page/FindBook";
import ActivityTimeline from "@/components/Activity/Timeline";
import ReviewChart from "@/components/Book/ReviewChart";
import ReaderTable from "@/components/Assignment/ReaderTable";
import NoContent from "@/components/Page/NoContent";
import { mapState } from "vuex";

export default {
  name: "ReaderPage",
  components: {
    Head,
    Heading,
    list: List,
    FindBook,
    ReviewChart,
    ReaderTable,
    "activity-timeline": ActivityTimeline,
    NoContent,
  },
  computed: {
    ...mapState({
      user: "user",
      assignments: "assignments",
      events: "events",
    }),
    showHistoryTable() {
      if (this.$store.state.user) {
        return this.$store.state.user.readerStats.history_table
      }
      return false
    },
    isIneligible() {
      if (this.user) {
        return this.user.is_friend
      }
      return false
    },
  },
  data: function () {
    return {};
  },
  async mounted() {},
};
</script>

<style scoped>
.content-container {
  max-width: 1000px !important;
  margin-left: 4px;
  border-bottom: 0;
}

.section-divider {
  width: 100%;
  height: 40px;
}

.add-book {
  display: block;
  margin: 0 auto;
  width: 200px;
  height: 52px;
  border-radius: 52px;
  border: 1px solid #ddd;
}
.add-icon {
  float: left;
  width: 32px;
  margin: 0px 0 0 32px;
  font-size: 26pt;
  text-align: center;
  color: #2196f3;
}
.add-label {
  float: left;
  width: 120px;
  margin: 10px 0 0 6px;
  font-size: 15pt;
  font-weight: 600;
  color: #2196f3;
  font-family: "Source Sans Pro";
}

.add-book:hover {
  box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: scale(1.05);
}
.grow {
  transition: all 0.1s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.activity-col {
  padding-left: 12px;
  max-width: 710px;
}

.find-book-container {
  margin-bottom: 16px;
}

.disable-message {
  /* float: center; */
  /* text-align: center; */
  margin-left: 4rem;
  color: red;
}

@media (max-width: 1024px) {
  .add-book-container {
    padding-top: 8px;
    padding-bottom: 20px;
  }

  .activity-col {
    padding-left: 0;
  }
}
</style>